import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './focus-area-blind.module.css'

const propTypes = {
    className: PropTypes.string,
    isShown: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    style: PropTypes.object // eslint-disable-line react/forbid-prop-types
}

/**
 * This is a generic blinds overlay functional component that is used by the FocusArea.
 * It's exact position is defined with the 'style' prop.
 * The color, opacity and any other visual styling can be overridden by passing a className.
 */
const FocusAreaBlind = props => {
    const { className, isShown, onClick, style } = props
    const blindClassName = cx(className, styles['blind'], styles[isShown ? 'show' : 'hide'])

    return <div onClick={onClick} className={blindClassName} style={style} />
}

FocusAreaBlind.propTypes = propTypes

export default FocusAreaBlind
